<template>
  <div>
    <div class="inner_about">
      <h3 class="about">About</h3>
      <p>
        My name is Tomoyuki Koizumi.
        <br />I live in Aichi, Japan.
        <br />I like 3D and I'm active under the handle name, Yukidoke.
      </p>
      <h3 class="skills">Skills</h3>
      <p>HTML / CSS / JavaScript / Three.js / Vue.js</p>
      <a href="https://twitter.com/snowdoke" target="_blank">
        <img src="@/assets/twitter_black.png" />
      </a>
    </div>
    <p class="copyright">© Yukidoke All Rights Reserved.</p>
  </div>
</template>

<script>
if (document.URL.match("/about/")) {
  document.addEventListener("DOMContentLoaded", function() {
    document.getElementById("about_click").click();
  });
}
</script>

<style>
h3,
p {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
}

.inner_about {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
}

.inner_about h3 {
  font-size: 30px;
  font-family: "Saira Semi Condensed", serif;
  color: #000;
}

.inner_about p {
  font-size: 24px;
  font-family: "Saira Semi Condensed", serif;
  color: #000;
  margin-top: 24px;
}

.skills {
  margin-top: 36px;
}

.inner_about a {
  margin-top: 50px;
}

.inner_about img {
  width: 50px;
  height: 50px;
}

@media screen and (max-width: 414px) {
  .inner_about h3 {
    font-size: 24px;
  }

  .inner_about p {
    font-size: 18px;
    margin-top: 18px;
    margin-left: 26px;
    margin-right: 26px;
  }

  .skills {
    margin-top: 24px;
  }

  .inner_about a {
    margin-top: 40px;
  }

  .copyright {
    font-size: 14px;
  }
}

@media screen and (max-width: 320px) {
  .inner_about p {
    margin-top: 12px;
  }

  .skills {
    margin-top: 20px;
  }

  .inner_about a {
    margin-top: 30px;
  }

  .copyright {
    font-size: 12px;
  }
}

@media (orientation: landscape) and (max-width: 812px) {
  .inner_about p {
    margin-top: 0;
    font-size: 20px;
  }

  .inner_about h3 {
    font-size: 27px;
  }

  .skills {
    margin-top: 4px;
  }

  .inner_about a {
    margin-top: 12px;
  }

  .copyright {
    font-size: 14px;
  }
}

@media (orientation: landscape) and (max-width: 667px) {
  .inner_about p {
    margin-top: 0;
    font-size: 16px;
  }

  .inner_about h3 {
    font-size: 24px;
  }

  .skills {
    margin-top: 4px;
  }

  .inner_about a {
    margin-top: 10px;
  }

  .copyright {
    font-size: 12px;
  }
}
</style>